import { render, staticRenderFns } from "./addOrUpdateDialog.vue?vue&type=template&id=52ea1518&"
import script from "./addOrUpdateDialog.vue?vue&type=script&lang=js&"
export * from "./addOrUpdateDialog.vue?vue&type=script&lang=js&"
import style0 from "./addOrUpdateDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports